import { localizeValue } from '@mnd-frontend/utils';
import { memo } from 'react';
import styled from 'styled-components';
import LegendIcon from '../Legend/LegendIcon';

const TooltipItemStyle = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-top: 0.5rem;
  }
  > *:last-child {
    font-weight: 600;
    margin-left: auto;
    padding-left: 2rem;
  }
`;

const TooltipItem = memo(({ color, name, value, precision = 0 }: any) => (
  <TooltipItemStyle>
    {color && <LegendIcon color={color} size={0.75} />}
    <div>{name}</div>
    <div>{Number.isFinite(value) ? localizeValue(value, { precision }) : value || ''}</div>
  </TooltipItemStyle>
));

export default TooltipItem;
